import { render } from "./ClassmateDetail.vue?vue&type=template&id=5399101e&scoped=true"
import script from "./ClassmateDetail.vue?vue&type=script&lang=js"
export * from "./ClassmateDetail.vue?vue&type=script&lang=js"

import "./ClassmateDetail.vue?vue&type=style&index=0&id=5399101e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5399101e"],['__file',"src/views/h5/luqiao/project/classmate/ClassmateDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5399101e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5399101e', __exports__)) {
    api.reload('5399101e', __exports__)
  }
  
  module.hot.accept("./ClassmateDetail.vue?vue&type=template&id=5399101e&scoped=true", () => {
    api.rerender('5399101e', render)
  })

}


export default __exports__